import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { theme, cardStyle, btnStyle } from '../theme';

const sevColor = { high: '#dc2626', medium: '#f59e0b', low: '#6b7280' };

const FraudDetectionPage = ({ API_BASE }) => {
  const [days, setDays] = useState(30);
  const [scan, setScan] = useState(null);
  const [loading, setLoading] = useState(false);

  const runScan = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_BASE}/fraud-detection/scan?days=${days}`);
      setScan(data);
    } catch (e) { alert('Scan failed: ' + (e.response?.data?.error || e.message)); }
    finally { setLoading(false); }
  };

  useEffect(() => { runScan(); /* eslint-disable-next-line */ }, []);

  return (
    <div>
      <div style={{ ...cardStyle, marginBottom: 14 }}>
        <h2 style={{ margin: 0, color: theme.navy }}>🚨 Fraud Detection</h2>
        <p style={{ margin: '6px 0 12px', fontSize: 13, color: theme.textMuted }}>
          Heuristic scan for cash anomalies, duplicate billing, phantom patients, discount abuse, and unallocated collections. Read-only — review and act manually.
        </p>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <label style={{ fontSize: 13 }}>Window:</label>
          <select value={days} onChange={e => setDays(Number(e.target.value))} style={{ padding: 6, borderRadius: 6 }}>
            <option value={7}>Last 7 days</option>
            <option value={30}>Last 30 days</option>
            <option value={90}>Last 90 days</option>
            <option value={180}>Last 6 months</option>
          </select>
          <button onClick={runScan} disabled={loading} style={{ ...btnStyle, marginTop: 0 }}>
            {loading ? 'Scanning…' : 'Run Scan'}
          </button>
        </div>
      </div>

      {scan && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px,1fr))', gap: 10, marginBottom: 14 }}>
            <Stat label="High-risk" value={scan.summary.high} color={sevColor.high} />
            <Stat label="Medium-risk" value={scan.summary.medium} color={sevColor.medium} />
            <Stat label="Low-risk" value={scan.summary.low} color={sevColor.low} />
            <Stat label="Bills scanned" value={scan.counts.bills} />
            <Stat label="Payments scanned" value={scan.counts.payments} />
          </div>

          <div style={cardStyle}>
            <h3 style={{ margin: '0 0 12px' }}>Alerts ({scan.alerts.length})</h3>
            {scan.alerts.length === 0
              ? <p style={{ color: theme.success }}>✅ No suspicious patterns detected in the last {scan.scannedDays} days.</p>
              : scan.alerts.map((a, i) => (
                <div key={i} style={{ borderLeft: `4px solid ${sevColor[a.severity]}`, background: '#f9fafb', padding: '10px 14px', marginBottom: 10, borderRadius: 6 }}>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: sevColor[a.severity], textTransform: 'uppercase' }}>{a.severity}</span>
                    <strong style={{ color: theme.navy }}>{a.title}</strong>
                  </div>
                  <div style={{ fontSize: 13, color: theme.textMuted, marginTop: 4 }}>{a.detail}</div>
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

const Stat = ({ label, value, color }) => (
  <div style={{ ...cardStyle, padding: 12 }}>
    <div style={{ fontSize: 11, color: theme.textMuted, textTransform: 'uppercase', fontWeight: 700 }}>{label}</div>
    <div style={{ fontSize: 22, fontWeight: 800, color: color || theme.navy }}>{value}</div>
  </div>
);

export default FraudDetectionPage;
